import './vendor';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')

import Swiper, { Autoplay, Pagination, Navigation} from 'swiper';
Swiper.use([Autoplay, Pagination, Navigation]);



let li = document.querySelectorAll(".listblock-1 li");
for(let i = 8; i < li.length; i++) {
	li[i].classList.add("hide-mobile");
}

let li2 = document.querySelectorAll(".listblock-2 li");
for(let i = 8; i < li2.length; i++) {
	li2[i].classList.add("hide-mobile");
}

$(".more-ru").click(function() {
	$(this).text(function(i, text){
		return text === "Свернуть список" ? "Развернуть весь список" : "Свернуть список";
	})
	$(this).parents(".container").find(".hide-mobile").toggleClass("is-visible");
});


$(".more-en").click(function() {
	$(this).text(function(i, text){
		return text === "Hide" ? "Show all list" : "Hide";
	})
	$(this).parents(".container").find(".hide-mobile").toggleClass("is-visible");
});




const swiper = new Swiper('.reviews', {
	// configure Swiper to use modules
	modules: [Pagination, Navigation],
	slidesPerView: 3,
	slidesPerGroup: 3,
	spaceBetween: 24,
        // loop: true,
	speed: 1000,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	autoplay: {
		delay: 2000,
	},
	breakpoints: {
		1024: {
			slidesPerView: 3,
			slidesPerGroup: 3,
		},
		768: {
			slidesPerView: 3,
			slidesPerGroup: 3,
			spaceBetween: 24,
		},
		320: {
			slidesPerView: 2,
			slidesPerGroup: 2,
		}
	}
});

/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$(".form").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "/assets/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$(".done-w").fadeIn();
		setTimeout(function() {
			// Done Functions
			$(".done-w").fadeOut();
			$.magnificPopup.close();
			th.trigger("reset");
		}, 3000);
	});
	return false;
});

$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
	disableOn: 700,
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 160,
	preloader: false,

	fixedContentPos: false
});


$(".scroll").on("click","a", function (event) {
    // исключаем стандартную реакцию браузера
    event.preventDefault();

    // получем идентификатор блока из атрибута href
    var id  = $(this).attr('data-scroll-to'),

    // находим высоту, на которой расположен блок
        top = $(id).offset().top;

    // анимируем переход к блоку, время: 800 мс
    $('body,html').animate({scrollTop: top}, 800);
});

